import './../../index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const ItAccreditationSize24Component = (props, ref) => (jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M17.7174 22V12.087H20.5V8.95655H17.7174V3.73913H14.587L14.587 8.95655H11.8044V12.087H14.587L14.587 22H17.7174Z", fill: "var(--magritte-ui-icon-color)" }), jsx("path", { d: "M9.41303 8.95651H3.5V12.0869H6.2826V22H9.41303V8.95651Z", fill: "var(--magritte-ui-icon-color)" }), jsx("path", { d: "M7.84777 6.34782C9.04839 6.34782 10.0217 5.37453 10.0217 4.17392C10.0217 2.9733 9.04839 2.00001 7.84777 2.00001C6.64716 2.00001 5.67387 2.9733 5.67387 4.17392C5.67387 5.37453 6.64716 6.34782 7.84777 6.34782Z", fill: "var(--magritte-ui-icon-color)" })] }));
const ItAccreditationSize24 = hoc(forwardRef(ItAccreditationSize24Component), 'ItAccreditationSize24');

export { ItAccreditationSize24 as default };
//# sourceMappingURL=ItAccreditationSize24.js.map
